// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DivWrapper } from "@eisinc/XDL/constants";
import { color, layoutContainer } from "@eisinc/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    widgetId: string;
}

interface CheckoutHeaderStyles {
    container?: InjectableCss;
    innerContainer?: InjectableCss;
    logoContainer?: InjectableCss;
    myAccountContainer?: InjectableCss;
}

const checkoutHeaderStyles: CheckoutHeaderStyles = {
    container: {
        css: css`
            width: 100%;
            box-shadow: 0 1px 0 0 ${color("common.ui3")};
            padding-block: 8px;
        `,
    },
    innerContainer: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            ${layoutContainer}
        `,
    },
    logoContainer: {
        css: css`
            .logo-link {
                max-width: 130px;
                .img {
                    max-width: 100%;
                    max-height: 100%;
                    width: auto;
                    height: auto;
                }
            }
        `,
    },
    myAccountContainer: {
        css: css`
            ${DivWrapper} {
                display: flex;
            }
        `,
    },
};

const styles = checkoutHeaderStyles;
const CheckoutHeader: FC<OwnProps> = ({ widgetId }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CheckoutHeader" {...{ blueprintName: BLUEPRINT_NAME }}>
            <StyledWrapper {...styles.innerContainer}>
                <StyledWrapper {...styles.logoContainer}>
                    <Zone contentId={widgetId} zoneName="Logo" />
                </StyledWrapper>
                <StyledWrapper {...styles.myAccountContainer}>
                    <Zone contentId={widgetId} zoneName="SignIn" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CheckoutHeader;
